import React, { Component } from "react";


class FilialList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchInputText: null,
            foundPoints: [],
        };
    }

    renderAdress(item) {
        if (this.props.isCity) return item.name;
        if (item.city.name) {
            return `${item.city.name}, ${item.street}, ${item.house}`;
        } else {
            const city = this.props.cities.find((city) => city.id === item.city)
            return `${city.name}, ${item.street}, ${item.house}`;
        }
    }

    checkSelectAllFilials() {
        const { addForm } = this.props;
        const checkbox = document.getElementById('checkbox_all_point')
        if (checkbox)
            checkbox.indeterminate = false;

        if (addForm.allPoints || (addForm.filial.length === this.state.foundPoints.length && this.state.foundPoints.length > 0))
            return 1;

        if (addForm.filial.length > 0 && addForm.filial[0] !== '') {
            if (checkbox)
                checkbox.indeterminate = true;
            return -1;
        }

        return 0;
    }

    changeSearchInput(value) {
        const { filials } = this.props;

        if (value && value !== '') {
            const filteringPoints = filials.filter((item) => this.renderAdress(item).trim().toLowerCase().replace(/[,\s.]/gi, '').includes(value.trim().toLowerCase().replace(/[,\s.]/gi, '')));
            this.setState({ foundPoints: filteringPoints, searchInputText: value });
        } else {
            this.resetFoundPoints(true)();
        }
    }

    resetFoundPoints = (reset) => () => {
        const { filials } = this.props;
        if (!filials || filials.length === 0) {
            this.setState({ foundPoints: [] });
            return;
        }

        if (this.state.searchInputText === '' || this.state.searchInputText === null || reset) {
            this.setState({
                foundPoints: filials,
                searchInputText: null
            });
        }

        const input = document.querySelector('.point_add_user_search-input');

        if (input && reset)
            input.value = null;
    }

    componentDidMount() {
        this.resetFoundPoints(false)();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.filials !== this.props.filials) this.resetFoundPoints(false)();
    }
    
    render() {
        const { addForm: { filial, allPoints }, filials, loadingFilials, isCity } = this.props;
        return(
            <div className="kt-wizard-v2__form" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {!loadingFilials &&
            <>
                {this.state.foundPoints.length > 0 ?
                    this.props.renderButtonAllFilials && (
                        <div
                            className='point_add_user_checkbox-div'
                            onClick={() => this.props.setAll()}
                        >
                            <input type='checkbox' id='checkbox_all_point' checked={(this.checkSelectAllFilials() === 1 ? true : this.checkSelectAllFilials() === 0 && false) || allPoints} />
                            <span>Выбрать все{this.state.foundPoints.length !== filials.length ? ' показанные' : ''}</span>
                        </div>
                    )
                    :
                    <div
                        className='point_add_user_checkbox-div'
                    >
                        <span>{isCity ? 'Городов не найдено' : 'Филиалов не найдено'}</span>
                    </div>
                }
                <div
                    className='point_add_user_checkbox-div'
                    style={{ cursor: 'auto' }}
                >
                    <input className='point_add_user_search-input' placeholder={isCity ? 'Поиск городов' : 'Поиск филиалов'} value={this.state.searchInputText} onChange={((e) => { this.changeSearchInput(e.target.value) })} />
                    {this.state.foundPoints.length !== filials.length &&
                        <>
                            <span className='css-1okebmr-indicatorSeparator' style={{ margin: '0px' }}></span>
                            <div className='css-tlfecz-indicatorContainer' style={{ padding: '0px', cursor: 'pointer' }} onClick={this.resetFoundPoints(true)}> <i className="flaticon2-cross" /> </div>
                        </>
                    }
                </div>
            </>
            }
            {
                this.state.foundPoints.map((item) => (
                    <div
                        key={item.id}
                        className='point_add_user_checkbox-div'
                        onClick={() => this.props.set(item)}
                    >
                        <input type='checkbox' checked={(filial.find((fil) => String(fil) === String(item.id)) ? true : false) || allPoints} />
                        {this.renderAdress(item)}
                    </div>
                ))
            }
            </div>
        );
    }
}

export default FilialList;